import axios from "axios";
const baseUrl =
  process.env.NODE_ENV === "production"
    ? "https://us-central1-eventform-eaec5.cloudfunctions.net/"
    : "http://localhost:5000/eventform-eaec5/us-central1/";

export default {
  install(Vue) {
    Vue.prototype.$axios = options => {
      const url = `${baseUrl}${options.url}`;
      return axios({
        ...options,
        url
      });
    };
    return Vue;
  }
};
